// Procession page behaviour ONLY, for use alongside the static site's shared
// furniture bundle (which supplies nav/search/theme/zoom behaviour and binds
// nothing procession-specific). Loaded by layouts/procession.html.haml when
// StaticFurniture is available; the fallback branch loads the full tlms entry.
import 'lazysizes';
import processionList from '~/packs/tlms/procession';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('#processional_order').forEach((el) => processionList(el));
});
